import { create } from 'zustand'

const initialState = {
  imageUrls: {},

  ydocRef: null,
  yPathsRef: null,
  yScopeRef: null,
  yTranslateRef: null,

  triggerAddPath: () => console.warn('triggerAddPath not initialized'),
  triggerUpdatePath: () => console.warn('triggerUpdatePath not initialized'),
  triggerUpdateTranslateAndScope: () =>
    console.warn('triggerUpdateTranslateAndScope not initialized'),
}

export const useWhiteboardStore = create((set) => ({
  ...initialState,

  // 상태와 액션을 업데이트할 함수
  setImageUrls: (urls) => set({ imageUrls: urls }),

  setYjsRefs: (refs) =>
    set({
      ydocRef: refs.ydocRef,
      yPathsRef: refs.yPathsRef,
      yScopeRef: refs.yScopeRef,
      yTranslateRef: refs.yTranslateRef,
    }),

  // Whiteboard 컴포넌트에서 생성된 실제 액션 함수들을 스토어에 연결하는 함수
  setYjsActions: (actions) =>
    set({
      triggerAddPath: actions.triggerAddPath,
      triggerUpdatePath: actions.triggerUpdatePath,
      triggerUpdateTranslateAndScope: actions.triggerUpdateTranslateAndScope,
    }),

  resetYjsData: () => set(initialState),
}))
